import { CDN_DOWNLOAD_BASE_URL, STUB_IMAGE_ID } from '@/constants/constants';

export const getImageLink = (id: string | null) => `${CDN_DOWNLOAD_BASE_URL}/${id || STUB_IMAGE_ID}`;
